import { CellProps } from 'react-table'
import {
  ChipListCell,
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { Enum, formatDateToPtBr } from '../../../../../../../_metronic/helpers'
import { ClientesActionsCell } from './ClientesActionsCell'
import { EmpresaList } from '../../../empresas-list/core/_models'
import { TFunction } from '_metronic/i18n/Metronici18n'

// Mesmo padrão da listagem de Instituição (empresas-list/table/columns/_columns.tsx).
export const clientesColumns = (t: TFunction): ReadonlyArray<TableColumn<EmpresaList>> => [
  // CNPJ é a linha de apoio do nome fantasia; os dois seguem ordenáveis.
  sortableColumn<EmpresaList>({
    id: 'nomeFantasia',
    cellWidth: '320px',
    useQueryRequest,
    fields: [
      { field: 'nomeFantasia', label: t('cols.nomeFantasia') },
      { field: 'cnpj', label: t('cols.documento.cnpj') },
    ],
    Cell: ({ row }) => (
      <StackedCell tabular primary={row.original.nomeFantasia} secondary={row.original.cnpj} />
    ),
  }),
  // terminoContrato é LocalDate puro: formatDateToPtBr evita o deslocamento de fuso.
  {
    Header: () => <PlainHeader>{t('cols.terminoContrato')}</PlainHeader>,
    id: 'terminoContrato',
    cellWidth: '168px',
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <StackedCell
        tabular
        primary={formatDateToPtBr(row.original.terminoContrato ?? '') || undefined}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.contratos')}</PlainHeader>,
    id: 'tiposContrato',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <ChipListCell
        items={(row.original.tiposContratoMap ?? []).map((item: Enum) => item.descricao)}
        noun={{ singular: 'serviço', plural: 'serviços' }}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.status')}</PlainHeader>,
    id: 'ativa',
    cellWidth: '112px',
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <StatusBadge active={row.original.ativa} labels={['Ativa', 'Inativa']} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<EmpresaList>) => <ClientesActionsCell empresa={row.original} />,
  },
]
